export const notAllowedQuestionnaireMessage =
	'You don`t have the rights to edit this card. You can only view it once it has the status "Done".';

export const questionnaireNotFoundError = {
	errorMessage: "Questionnaire doesn't exist",
	field_errors: { exist: 'exist' },
};
